import {Component, HostBinding, HostListener, ElementRef} from '@angular/core';
import {Http,  Headers, RequestOptions} from '@angular/http';
import {AppService} from '../../../../shared/services/app-service';

// Services
import {CatalogService} from '../../services/catalog-service';
import {NavigationService} from '../../../../shared/services/navigation-service';

import {CartService} from '../../services/cart-service';
import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';
import {GeneratorsService} from '../../services/generators-service';
import {Product, ProductConfig} from '../../classes/product';


declare var $;
let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:EmailSummaryCmp'));

@Component({
    selector: 'email-summary-cmp',
    template: require('./email-summary.cmp.html'),
    styles: [String(require('./email-summary.cmp.scss'))],
    host: { class: 'email-summary' }
})


export class EmailSummaryCmp {

    emailForm = {
        txtName: null,
        txtEmail: null,
        txtAddresses: null,
        txtNotes: null,
        selHsPersona: null
    };



    emailModalElement = null;
    dom: any = {};

    show = true;
    pruducts;
   
    private _generatorCfg;
    private _roomDimensions;
    private _imgPaths;
    private _summaryElement = null;
    private _globals = null;
    

    
    
     //you need data here
    //product.partnumber ....

    private _dic = {
        stone: 'Natural Stone',
        ceramic: 'Ceramic, Porcelain, Glass Tile',
        acrylic: 'Acrylic, Fiberglass, Composite'
    };

    
    

    constructor(
        private _cartService: CartService,
        private _elementRef: ElementRef,
        private _http: Http,
        private _appService: AppService,
        private _generatorsService: GeneratorsService,
        private _catalogService: CatalogService,
        private _navigationService: NavigationService
        
     
    
    ) 
    {
        // 'Construct email summary component' );

        var self = this;

        this.emailModalElement = _elementRef.nativeElement;

        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;

        this._imgPaths = this._catalogService.imgPaths;
        this._summaryElement = _elementRef.nativeElement;

        this._globals = this._catalogService.getGlobals();

       
       
      
    //   this.product = 
        //this.partnumber = this._config.partnumber;
      
    }

    

    
    ngOnInit() {
        // 'Initialise email summary component' );
        
        this._cartService.productEvent.subscribe(() => {
            console.log(this._cartService.cartProducts,111);
            this.pruducts = this._cartService.cartProducts;
        })

        this.dom.txtName = document.getElementById('txtName');
        this.dom.txtEmail = document.getElementById('txtEmail');
        this.dom.txtAddresses = document.getElementById('txtAddresses');
        this.dom.txtNotes = document.getElementById('txtNotes');       
        this.dom.lblEmailMessage = document.getElementById('lblEmailMessage');
        this.dom.lblSentMessage = document.getElementById('lblSentMessage');
        this.dom.divSelection = document.getElementById('products-selection');
        this.dom.selHsPersona = document.getElementById('selHsPersona');
        this.dom.divSelectionEmail = document.getElementById('content-email');


        // hide content email div
        document.getElementById('content-email').style.display = "none";
    
    }

    
    ngOnDestroy() {
        // 'Destroy email summary component' );
    }

    clearTextarea() {

        var txtAddresses = this.dom.txtAddresses.value;

        if (txtAddresses === 'Enter up to 10 emails separated by commas...') {
            this.dom.txtAddresses.value = '';
            return;
        } 

    }

    setTextarea() {
        var textareaMessage = 'Enter up to 10 emails separated by commas...';

        var txtAddresses = this.dom.txtAddresses.value;

        if (txtAddresses === '') {
            this.dom.txtAddresses.value = textareaMessage;
            return;
        } else {
            var n = txtAddresses.indexOf(';');
            if (n != -1) {
                this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
            } else {
                this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
            }

        }

    }

   

    emailSelectionToAddresses() {


        var self = this,
            txtName = this.dom.txtName.value;

        if (txtName === '') {
            this.dom.txtName.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtName.style.backgroundColor = '#FFFFFF';
        }

        var txtEmail = this.dom.txtEmail.value;
        if (txtEmail === '') {
            this.dom.txtEmail.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtEmail.style.backgroundColor = '#FFFFFF';
        }

        var txtAddresses = this.dom.txtAddresses.value;
        if (txtAddresses === '') {
            this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
        }
        else {
            this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
        }

        if (txtName === '' || txtEmail === '') {

            this.dom.lblSentMessage.innerHTML = '';
            return;

        }

        //Multiple addresses is not necessary
        //if (txtName === '' || txtEmail === '' || txtAddresses === '') {

        //    this.dom.lblSentMessage.innerHTML = '';
        //    return;

        //}

        // Data to send
        var cust = {
            Name: txtName,
            Email: txtEmail
        };


        var strRecipients;
        strRecipients = this.dom.txtAddresses.value;
        var arrRecipients = strRecipients.split(',');
        var recipients = [];
        for (var e in arrRecipients) {

            var email = arrRecipients[e]

            if (email !== null && email !== "" && email.trim() !=="" )
            {
                var recipient = { 'Email': email.trim() };

                recipients.push(recipient);
            }

        }


        if (recipients.length === 0) {
            this.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
        } else {
            this.dom.txtAddresses.style.backgroundColor = '#FFFFFF';
        }

        var notes = this.dom.txtNotes.value,
        content = this.dom.divSelection.innerHTML;

        content = this.dom.divSelectionEmail.innerHTML;
        content = content.replace("media/", "http://virtualspa.mrsteam.com/media/");
        //alert(content);

        var persona_value = this.dom.selHsPersona.value;
        var persona = '';
        if (persona_value != 'persona_0')
        {
            persona = this.dom.selHsPersona.options[this.dom.selHsPersona.selectedIndex].text;
        }


        // Send Email
        var data = {
            //SequenceID: 1,
            Customer: cust,
            //ProductSelection: this._cartService.getCartProducts(),
            Recipients: recipients,
            EmailContent: notes + '<br /><br />' + content,
            Persona: persona
        };

        let body = JSON.stringify(data);
        //let headers = new Headers({ 'Content-Type': 'application/json' });
        //let options = new RequestOptions({ headers: headers });


        //this._http.post('/api/steps', body, options)
           // .map(res => res.json())
           // .subscribe(
            //    success => handleSuccess(),
            //    error => handleError(error)
         //   );

        //var baseURL = 'http://mailsmtp.asitcon.com';
        //var baseURL = 'https://mailsmtp.sussmancorp.com';
        var baseURL = 'https://mailsmtp.mrsteam.com';
        //var baseURL = 'https://localhost:44319';
  

        this._appService.hideEmailSummaryModal();
        this._appService.displayAlertModal();


        $.ajax({
             type: "POST",
             data: body,
             url: baseURL + '/mail',
             contentType: "application/json; charset=utf-8",
             dataType: 'json'
         }).done(function (res: any) {
            //alert(res)
             //console.log('res', res);

             // Success
            //alert("Sent ...");

            //this._appService.hideEmailSummaryModal();
            //this._appService.displayAlertModal();

            //handleSuccess();
            //alertModal();
        
         }).fail(function(jqXHR, status, exception) {
            // show error 
            var msg = '';
            if (jqXHR.status === 0) {
                msg = 'Not connect.\n Verify Network.';
            } else if (jqXHR.status == 404) {
                msg = 'Requested page not found. [404]';
            } else if (jqXHR.status == 500) {
                msg = 'Internal Server Error [500].';
            } else if (exception === 'parsererror') {
                msg = 'Requested JSON parse failed.';
            } else if (exception === 'timeout') {
                msg = 'Time out error.';
            } else if (exception === 'abort') {
                msg = 'Ajax request aborted.';
            } else {
                msg = 'Uncaught Error.\n' + jqXHR.responseText;
            }

            //alert(exception);

            alert("Error  - errorThrown: " + exception + " -  jqXHR.responseText: " + jqXHR.responseText+ " -  jqXHR.status: " + jqXHR.status + " -  textStatus: " + status);

            // status
            //msg = status;
            //alert('status: ' + msg);

            // error handling
            handleError(exception);
        });

        function handleSuccess () {

            self.dom.lblSentMessage.innerHTML = 'Email sent successfully!';
            self.dom.txtName.style.backgroundColor = '#E8F4FF';
            self.dom.txtEmail.style.backgroundColor = '#E8F4FF';
            self.dom.txtAddresses.style.backgroundColor = '#E8F4FF';
            self.dom.txtNotes.style.backgroundColor = '#E8F4FF';
            self.dom.selHsPersona.style.backgroundColor = '#E8F4FF';
            self.dom.products.style.visibility = "hidden";
            self.dom.btnsend.style.visibility = "hidden";
        }

        function handleError (error) {
            // alert(error);
            // alert('Error  occurred');
            console.log('Error  occurred', error);
            self.dom.lblSentMessage.innerHTML = 'Error  occurred!';
            self.dom.txtName.style.backgroundColor = '#FFE6E6';
            self.dom.txtEmail.style.backgroundColor = '#FFE6E6';
            self.dom.txtAddresses.style.backgroundColor = '#FFE6E6';
            self.dom.txtNotes.style.backgroundColor = '#FFE6E6';
            self.dom.selHsPersona.style.backgroundColor = '#FFE6E6';
        }

        this.emailForm = {
            txtName: null,
            txtEmail: null,
            txtAddresses: null,
            txtNotes: null,
            selHsPersona: null
        };

        this.emailModalElement = null;
        self.dom.lblSentMessage.innerHTML = '';
        self.dom.txtName = document.getElementById('txtName');
        self.dom.txtEmail = document.getElementById('txtEmail');
        self.dom.txtAddresses = document.getElementById('txtAddresses');
        self.dom.txtNotes = document.getElementById('txtNotes');
        self.dom.lblEmailMessage = document.getElementById('lblEmailMessage');
        self.dom.lblSentMessage = document.getElementById('lblSentMessage');
        self.dom.divSelection = document.getElementById('products-selection');
        self.dom.selHsPersona = document.getElementById('selHsPersona');
        self.dom.divSelectionEmail = document.getElementById('content-email');
        
    }


    private _roundRoomVolume(volume) {
        debugOff( 'Round room volume' );
        return Math.ceil(volume);
    }

    validateForm() { }

    close(){
        this.show = true;
        this._appService.hideEmailSummaryModal();
    }

}





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/modals/email-summary.cmp.ts